import React from 'react';
import { 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Box,
  Typography,
  Divider,
  useTheme,
} from '@mui/material';
import { 
  Dashboard as DashboardIcon,
  Create as CreateIcon,
  Schedule as ScheduleIcon,
  Share as ShareIcon,
  Analytics as AnalyticsIcon,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const menuItems = [
  { path: '/dashboard', label: 'Dashboard', icon: DashboardIcon },
  { path: '/content-generation', label: 'Content Generation', icon: CreateIcon },
  { path: '/schedule-posts', label: 'Scheduled Posts', icon: ScheduleIcon },
  { path: '/platform-integrations', label: 'Integrations', icon: ShareIcon },
  { path: '/analytics', label: 'Analytics', icon: AnalyticsIcon },
];

const Sidebar = ({ window, children }) => {
  const location = useLocation();
  const theme = useTheme();

  const drawer = (
    <Box>
      <Divider />
      <List>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <motion.div
              key={item.path}
              whileHover={{ x: 4 }}
              whileTap={{ scale: 0.98 }}
            >
              <ListItem
                button
                component={Link}
                to={item.path}
                sx={{
                  mb: 1,
                  borderRadius: 2,
                  bgcolor: isActive ? 'primary.light' : 'transparent',
                  color: isActive ? 'primary.main' : 'text.primary',
                  '&:hover': {
                    bgcolor: isActive ? 'primary.light' : 'rgba(0, 0, 0, 0.04)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? 'primary.main' : 'text.primary',
                    minWidth: 40,
                  }}
                >
                  <Icon />
                </ListItemIcon>
                <ListItemText 
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: '0.95rem',
                    fontWeight: isActive ? 600 : 500,
                    color: 'inherit',
                  }}
                />
                {isActive && (
                  <Box
                    sx={{
                      width: 4,
                      height: 32,
                      bgcolor: 'primary.main',
                      position: 'absolute',
                      right: 0,
                      borderRadius: '4px 0 0 4px',
                    }}
                  />
                )}
              </ListItem>
            </motion.div>
          );
        })}
      </List>
    </Box>
  );

  return (
    <Box
      sx={{
        height: '100%',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%)',
        borderRight: '1px solid rgba(0, 0, 0, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        pt: 8,
      }}
    >
      {drawer}
    </Box>
  );
};

export default Sidebar;
